import instance from 'utils/axios/instance.axios';
import { RESEARCH_KPIS } from './_constant';

export const getAll = () => instance.get(RESEARCH_KPIS.GET_ALL);

export const create = (data = {}) => instance.post(RESEARCH_KPIS.CREATE, data);

export const update = ({ id, data }) => instance.patch(RESEARCH_KPIS.UPDATE(id), data);

export const deleteById = (id) => instance.delete(RESEARCH_KPIS.DELETE(id));

export const restore = (id) => instance.patch(RESEARCH_KPIS.RESTORE(id));

export const reorder = (data = {}) => instance.post(RESEARCH_KPIS.REORDER, data);
